{
    "common": {
        "mon": "Pon",
        "tue": "Wt",
        "wed": "Śr",
        "thu": "Czw",
        "fri": "Pt",
        "sat": "Sob",
        "sun": "Niedz",
        "jan": "Sty",
        "feb": "Lut",
        "mar": "Mar",
        "apr": "Kwi",        
        "jun": "Cze",
        "jul": "Lip",
        "aug": "Sie",
        "sep": "Wrz",
        "oct": "Paź",
        "nov": "Lis",
        "dec": "Gru",
        "january": "Styczeń",
        "february": "Luty",
        "march": "Marzec",
        "april": "Kwiecień",
        "may": "Maj",
        "june": "Czerwiec",
        "july": "Lipiec",
        "august": "Sierpień", 
        "september": "Wrzesień",
        "october": "Październik",
        "november": "Listopad",
        "december": "Grudzień",
        "checkin": "Zameldowanie",
        "checkout": "Wymeldowanie",
        "room": "Pokój",
        "rooms": "Pokoje",
        "adult": "Dorosły",
        "adults": "Dorośli",
        "edit": "Edytuj",
        "editCap": "EDYTUJ",
        "delete": "Usuń",
        "deleteCap": "USUŃ",
        "localTime": "Czas lokalny",
        "back": "WSTECZ",
        "home": "DOM",
        "yes": "TAK",
        "no": "NIE",
        "left": "Pozostało",
        "hour": "Godzina",
        "hours": "Godziny",
        "night": "noc",
        "nights": "noce",
        "for": "dla",
        "why": "Dlaczego",
        "get": "Zdobądź",
        "more": "Więcej",
        "agree": "ZGADZAM SIĘ",
        "disagree": "NIE ZGADZAM SIĘ",
        "basedOn": "na podstawie",
        "error": "Wystąpił błąd, spróbuj ponownie później",
        "error2": "Niepowodzenie, spróbuj ponownie!",
        "error3": "Wystąpił błąd!!",
        "error4": "Wystąpił błąd!! Spróbuj ponownie",
        "error5": "Przepraszamy!! Wystąpił błąd. Spróbuj ponownie za jakiś czas.",
        "hi": "Cześć",
        "to": "do",
        "free": "Bezpłatnie",
        "per": "Na",
        "at": "o",
        "day": "Dzień",
        "days": "Dni",
        "time": "Czas",
        "of": "z",
        "photo": "Zdjęcie",
        "photos": "Zdjęcia",
        "done": "Gotowe",
        "fullStay": "Cały pobyt",
        "date": "Data",
        "and": "i",
        "bookingDetail": "Szczegóły rezerwacji",
        "Back": "Wstecz",
        "Home": "Dom"
    },
    "userPopup": {
        "myAccount": "Moje konto",
        "welcome": "Witamy",
        "user": "Użytkownik",
        "findMyBookings": "ZNAJDŹ MOJE REZERWACJE",
        "viewProfile": "ZOBACZ PROFIL",
        "makeAReservarion": "DOKONAJ REZERWACJI",
        "logout": "WYLOGUJ",
        "loginCap": "ZALOGUJ",
        "login": "Zaloguj",
        "invalidCredentials": "Nieprawidłowe dane logowania",
        "invalidEmail": "Nieprawidłowy e-mail",
        "passwordIsRequired": "Hasło jest wymagane",
        "minChar8": "minimum 8 znaków",
        "tooShort": "Za krótkie!",
        "tooLong": "Za długie!",
        "required": "Wymagane",
        "emailInvalid": "Wprowadź prawidłowy e-mail",
        "passwordInvalid": "Wprowadź prawidłowe hasło",
        "phNumInvalid": "Numer telefonu jest nieprawidłowy",
        "signupCap": "ZAREJESTRUJ SIĘ",
        "signup": "Zarejestruj się",
        "verifyText": "Zweryfikuj, że to ty",
        "verifyText2": "Wysłaliśmy kod weryfikacyjny na twój e-mail",
        "verificationCode": "Kod weryfikacyjny",
        "didNotReceiveEmail": "Nie otrzymałeś e-maila",
        "clickToResend": "Kliknij, aby wysłać ponownie",
        "verifyAndSignIn": "Zweryfikuj i zaloguj się",
        "otpSentSuccessfully": "OTP wysłano pomyślnie",
        "somethingWentWrong": "Coś poszło nie tak, spróbuj ponownie",
        "otpError": "Wprowadź prawidłowy numer",
        "otpError2": "Wprowadź tylko cyfry",
        "otpError3": "Nieprawidłowy OTP, spróbuj ponownie",
        "otpError4": "OTP wygasł, kliknij Wyślij ponownie, aby spróbować ponownie",
        "otpError5": "Spróbuj ponownie",
        "forgetPassword": "Zapomniałeś hasła",
        "submitError": "Użytkownik nie istnieje!",
        "userExistError": "Użytkownik już istnieje",
        "checkYourEmail": "Sprawdź swój e-mail",
        "passwordResetLinkSent": "Wysłaliśmy link do resetowania hasła na",
        "noWorriesResetInstructions": "Nie martw się, wyślemy ci instrukcje resetowania.",
        "enterYourEmail": "Wprowadź swój e-mail",
        "resetMyPassword": "ZRESETUJ MOJE HASŁO",
        "setANewPassword": "Ustaw nowe hasło",
        "newPassword": "Nowe hasło",
        "confirmPassword": "Potwierdź hasło",
        "confirmPasswordError": "Hasła muszą się zgadzać",
        "backToLogin": "Powrót do logowania",
        "dontHaveAccount": "Nie masz konta?",
        "alreadyHaveAccount": "Masz już konto?",
        "memberDiscount1": "Otrzymasz",
        "memberDiscount2": "zniżkę członkowską na zawsze.",
        "discount1": "Zarządzaj wszystkimi swoimi rezerwacjami z jednego miejsca.",
        "discount2": "Zarejestruj się, aby otrzymać spersonalizowane rekomendacje i dostosowane doświadczenia!!",
        "discount3": "Dołącz do naszej społeczności zadowolonych gości i zacznij planować swój pobyt.",
        "leftGridText1": "Zarządzaj wszystkimi swoimi rezerwacjami z jednego miejsca",
        "leftGridText2": "Zarejestruj się, aby otrzymać spersonalizowane rekomendacje i dostosowane doświadczenia!!",
        "leftGridText3": "Dołącz do naszej społeczności zadowolonych gości i zacznij planować swój pobyt",
        "gridDiscountText1": "zniżka członkowska na",
        "gridDiscountText2": "wybrane nieruchomości na zawsze",
        "gridDiscountText3": "Zaloguj się, aby otrzymać dostosowane doświadczenie na zawsze",
        "gridDiscountText4": "Uzyskaj ekskluzywne korzyści członkowskie",
        "findBookingError": "Twój e-mail i identyfikator rezerwacji nie pasują",
        "verifyAndConfirmBooking": "Zweryfikuj i potwierdź rezerwację",
        "confirmEmailText": "Wysłaliśmy kod weryfikacyjny na twój adres e-mail",
        "enterCodeText": "Wprowadź kod weryfikacyjny wysłany do ciebie",
        "didNotRecieveEmail": "Nie otrzymałeś e-maila?",
        "changeEmailText": "Kliknij tutaj, aby zmienić adres e-mail",
        "verifyAndConfirm": "Zweryfikuj i potwierdź",
        "verified": "ZWERYFIKOWANO",
        "bookingExpired": "Rezerwacja wygasła",
        "bookingExpiredText": "Przepraszamy, identyfikator rezerwacji, którego używasz, wygasł",
        "backToFindingBooking": "Powrót do znajdowania rezerwacji",
        "findMyBooking": "Znajdź moje rezerwacje",
        "bookingEmail": "E-mail rezerwacji",
        "reservationId": "Identyfikator rezerwacji",
        "findBooking": "ZNAJDŹ REZERWACJĘ",
        "abandonmentCartDoneText1": "Dziękujemy!",
        "abandonmentCartDoneText2": "Szczegóły koszyka zostały wysłane na e-mail. Kontynuuj rezerwację w dowolnym momencie.",
        "Recommended Currencies": "Zalecane waluty",
        "All currencies": "Wszystkie waluty",
        "thisIsRequiredField": "To pole jest wymagane"
    },
    "widget": {
        "destination": "Miejsce docelowe",
        "enterDestination": "Wprowadź miejsce docelowe",
        "guests": "Goście",
        "guest": "Gość",
        "nationality": "Narodowość",
        "selectNationality": "Wybierz narodowość",
        "nationalityIsRequired": "Narodowość jest wymagana",
        "selectedRate": "Specjalna stawka",
        "search": "Szukaj",
        "ages": "Wiek",
        "orAbove": "Lub więcej",
        "child": "Dziecko",
        "children": "Dzieci",
        "addAnotherRoom": "Dodaj kolejny pokój",
        "removeRoom": "Usuń pokój",
        "property": "Nieruchomość",
        "city": "Miasto",
        "country": "Kraj",
        "bookNow": "Zarezerwuj teraz",
        "overnightStay": "Pobyt noclegowy",
        "dayUse": "Użycie dzienne",
        "destinationIsRequired": "Miejsce docelowe jest wymagane",
        "checkInIsRequired": "Data zameldowania jest wymagana",
        "checkOutIsRequired": "Data wymeldowania jest wymagana",
        "noLocationFound": "Nie znaleziono lokalizacji",
        "soldOut": "Wyprzedane",
        "highDemand": "Wysokie zapotrzebowanie",
        "dates": "Daty",
        "allRates": "Wszystkie stawki są w",
        "K": "K",
        "M": "M",
        "sameDayCheckout": "Wymeldowanie tego samego dnia"
    },
    "promotion": {
        "headingText": "Ważne informacje dla",
        "regularRate": "Brak",
        "seniorCitizen": "Stawka dla seniorów",
        "agencyRate": "Stawka agencji",
        "caaRate": "Stawka CAA/AAA",
        "corporateRate": "Stawka korporacyjna",
        "governmentRate": "Stawka rządowa/wojskowa",
        "promotionalSpecialRate": "Stawka promocyjna/specjalna",
        "regularRateDescription": "Nie zastosowano żadnej promocji.",
        "seniorCitizenRateDescription": "To jest obniżona stawka hotelowa szeroko dostępna dla starszych osób dorosłych, zwykle w wieku 60 lat lub starszych.",
        "agencyRateDescription": "To jest obniżona stawka hotelowa oferowana, do której można uzyskać dostęp tylko za pośrednictwem określonych biur podróży, wspierających partnerstwo i współpracę.",
        "caaRateDescription": "To jest specjalna stawka hotelowa oferowana członkom AAA lub CAA dla ekskluzywnych oszczędności.",
        "corporateRateDescription": "To jest obniżona stawka hotelowa rozszerzona na podróżnych biznesowych, zwykle negocjowana między hotelem a podmiotem korporacyjnym.",
        "governmentRateDescription": "Ten plan stawek oferuje szczególne zniżki dla personelu rządowego/wojskowego na rezerwację pokoju hotelowego.",
        "contentSeniorCitizen": "Dowód daty urodzenia jest obowiązkowy w momencie zameldowania. Brak przedstawienia odpowiedniego dokumentu tożsamości spowoduje naliczenie obowiązujących opłat.",
        "contentAgencyRate": "Upewnij się, że masz potwierdzenie rezerwacji i dowód tożsamości po przyjeździe. Brak przedstawienia ich spowoduje zastosowanie standardowych stawek.",
        "contentPromotionalSpecialRate": "To jest obniżona stawka hotelowa oferowana przez ograniczony czas, często związana z określonymi wydarzeniami, sezonami lub kampaniami marketingowymi.",
        "contentCaaRate": "Upewnij się, że masz kartę członkowską CAA lub odpowiednią identyfikację w momencie zameldowania. Brak przedstawienia odpowiedniego dokumentu tożsamości spowoduje naliczenie obowiązujących opłat.",
        "contentCorporateRate": "Dowód tożsamości firmowej lub innej oficjalnej dokumentacji jest wymagany w momencie zameldowania. Brak przedstawienia odpowiedniego dowodu spowoduje naliczenie obowiązujących opłat.",
        "contentGovernmentRate": "Ważny identyfikator rządowy lub wojskowy musi być przedstawiony podczas zameldowania. Brak przedstawienia wymaganej identyfikacji spowoduje naliczenie opłat według stawki standardowej.",
        "CORP": "FIRMA",
        "AGEN": "AGENCJA",
        "PROM": "PROMOCJA",
        "apply": "ZASTOSUJ",
        "Offer Code": "Kod oferty",
        "Agency Code": "Kod agencji",
        "Corporate Code": "Kod firmowy",
        "All-Access Rate": "Stawka pełnego dostępu",
        "errorCode": "Ten kod jest nieważny"
    }
}